import * as types from '../../types'
import Immutable from 'immutable'

const INITIAL_STATE = Immutable.fromJS({
    saving: false,
    modalEditStatus: {
        show: false,
        data: {}
    }
})

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.SOLICITUDES_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.SOLICITUDES_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        case types.SOLICITUDES_MOSTRAR_MODAL_MODICAR_ESTADO_SOLICITUDES:
            state = state.setIn('modalEditStatus.show'.split('.'), action.payload.show)
            if (!action.payload.show) {
                state = state.set('modalEditStatus', INITIAL_STATE.get('modalEditStatus'))
            }
            return state
        default:
            return state
    }
}